@if (sections) {
  <mat-list>
    @for (section of sections; track section) {
      @if (section.subheading && section.projects.length > 0) {
        <h2 matSubheader>
          {{ section.subheading }}
        </h2>
      }
      @for (project of section.projects; track trackProject($index, project)) {
        <div
          class="project-item"
          gdGap="2px 4px"
          gdColumns="     72px        auto        "
          gdAreas="       icon        name        |
                    icon      description   "
        >
          <a
            gdArea="icon"
            [routerLink]="['/projects', project.id, 'detail']"
            [matTooltip]="
              project.autoApproveJoinRequests
                ? 'No approval required for new members'
                : 'Approval required for new members'
            "
          >
            <mat-icon
              class="syrf-icon"
              [ngClass]="{
                private: !project.autoApproveJoinRequests,
                member: project.isMember,
              }"
              svgIcon="syrf-front"
            ></mat-icon>
            <small class="lock-icon">
              <mat-icon
                inline
                [color]="project.autoApproveJoinRequests ? 'warn' : 'primary'"
                >{{
                  project.autoApproveJoinRequests ? 'lock_open_right' : 'lock'
                }}</mat-icon
              >
            </small>
          </a>
          <a
            gdArea="name"
            class="name"
            [routerLink]="['/projects', project.id]"
          >
            <div class="subheading" style="cursor: pointer">
              <span>{{ project.name }}</span>
            </div>
          </a>
          @if (project.description) {
            <div gdArea="description" class="description">
              {{ project.description | newline: 1 }}
            </div>
          }
        </div>
      }
    }
  </mat-list>
}
